import { onComposeStateChange } from '../actions/internalActions';
import { closeComposeInSxS, forceCloseSxS } from '../actions/publicLazyActions';
import sxsStore from '../store/Store';
import ItemId from 'owa-service/lib/contract/ItemId';
import { orchestrator } from 'satcheljs';

orchestrator(closeComposeInSxS, actionMessage => {
    const { composeViewState } = actionMessage;
    let shouldCloseSxS = false;

    if (composeViewState && composeViewState.composeId === sxsStore.composeId) {
        onComposeStateChange(null);

        if (!sxsStore.readingPaneState) {
            shouldCloseSxS = true;
        }
    }

    const composeItemId: ItemId = composeViewState?.itemId;
    const previewItemId = sxsStore.editState?.itemId;

    if (composeItemId && previewItemId && composeItemId.Id === previewItemId.Id) {
        shouldCloseSxS = true;
    }

    if (shouldCloseSxS) {
        forceCloseSxS('closeCompose');
    }
});
